import { useState } from "react";
import { Col, Tabs, Tab } from "react-bootstrap";

import { validRoles } from "@/services/Utils";

import { tabs_users } from "../../maintainers.module.scss";

import UsersRoles from "./UsersRoles";
import UsersNotifications from "./UsersNotifications";
import UsersPermissions from "./UsersPermissions";
import UsersProfiles from "./UsersProfiles";

const UsersTabs = ({ data, setData }) => {
	const [option, setOption] = useState("roles");

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isManager = validRoles(userRoles, ["administrador", "gerente_agricola", "administrador_campo"]);

	return (
		<Col md={12} xs={12} className={tabs_users}>
			<Tabs activeKey={option} id="users_tabs" onSelect={(k) => setOption(k)}>
				{isManager && (
					<Tab eventKey="roles" title="Roles">
						<UsersRoles data={data} setData={setData} />
					</Tab>
				)}
				<Tab eventKey="permissions" title="Permisos">
					<UsersPermissions data={data} setData={setData} />
				</Tab>
				<Tab eventKey="notifications" title="Notificaciones">
					<UsersNotifications data={data} setData={setData} />
				</Tab>
				<Tab eventKey="profiles" title="Perfiles">
					<UsersProfiles data={data} setData={setData} />
				</Tab>
			</Tabs>
		</Col>
	);
};

export default UsersTabs;
